import { FormProps } from './interface/form-props.interface';

export interface SubTaskDTO {
  text: string;
  completed: boolean;
  completedAt: string | null;
  completedBy: string | null;
}

export interface StageReminderDTO {
  triggerType: 'any_stage_change' | 'specific_stages';
  stageIds: string[];
}

export interface CreateTaskDTO {
  task: string;
  jobId: string;
  creator: string;
  date?: string | null;
  time?: string | null;
  completed?: boolean;
  assignedTo?: string[];
  priority?: string;
  status?: string;
  description?: string;
  subTask?: SubTaskDTO[];
  comments?: {
    text: string;
    userId: string;
    createdAt: string;
    editedAt?: string;
  }[];
  stageReminder?: StageReminderDTO | null;
}

export interface UpdateTaskDTO {
  taskId?: string;
  task?: string;
  jobId?: string;
  creator?: string;
  date?: string | null;
  time?: string | null;
  completed?: boolean;
  assignedTo?: string[];
  priority?: string;
  status?: string;
  description?: string;
  subTask?: SubTaskDTO[];
  comments?: {
    text: string;
    userId: string;
    createdAt: string;
    editedAt?: string;
  }[];
  stageReminder?: StageReminderDTO | null;
}

export class CreateTaskFormData {
  [key: string]: FormProps;

  task: FormProps = {
    name: 'task',
    label: 'Task Description',
    type: 'text',
    placeholder: 'Task'
  };
  jobId: FormProps = {
    name: 'jobId',
    label: 'Job',
    type: 'text',
    placeholder: 'Job'
  };
  creator: FormProps = {
    name: 'creator',
    label: 'Created By',
    type: 'text',
    placeholder: '123-456-789'
  };
  date: FormProps = {
    name: 'date',
    label: 'Date ',
    type: 'text',
    placeholder: '123-456-789'
  };
  badge: FormProps = {
    name: 'badge',
    label: 'badge',
    type: 'text',
    placeholder: 'badge'
  };
  time: FormProps = {
    name: 'time',
    label: 'time',
    type: 'time',
    placeholder: 'Due on'
  };
}
